import './App.css';
import BackToTop from './components/BackToTop/BackToTop';
import Clients from './components/Clients/Clients';
import ButtonCTA from './components/CTA/ButtonCTA';
import CTA from './components/CTA/CTA';
import Features from './components/Features/Features';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero/Hero';
import ImageGallery from './components/ImageGallery/ImageGallery';
import Kuliner from './components/Kuliner/Kuliner';
import Location from './components/Location/Location';
import Navbar from './components/Navbar/Navbar';
import Product from './components/Product/Product';
import Reservation from './components/Reservation/Reservation';
import Testimoni from './components/Testimoni/Testimoni';
import VideoCarousel from './components/VideoCarousel/VideoCarousel';
import WhyUs from './components/WhyUs/WhyUs';
import Wisata from './components/Wisata/Wisata';

function App() {
  return (
    <div className="App" id='home'>
      <Navbar />
      <Hero />
      <Features />
      <Product />
      <ImageGallery />
      <VideoCarousel />
      <WhyUs />
      <Reservation />
      <Testimoni />
      <Clients />
      <Wisata />
      <Kuliner />
      <Location />
      <CTA />
      <Footer />
      <ButtonCTA />
      <BackToTop />
    </div>
  );
}

export default App;
